import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Presencia Ejecutiva en 15 Min',
  desc: 'Rutina diaria de postura, voz y mirada.'
}, {
  title: 'El Mapa de Reuniones',
  desc: 'Leé la sala antes de decir una palabra.'
}, {
  title: 'Entrevista Impecable',
  desc: 'Protocolo completo de entrada a cierre.'
}, {
  title: 'Manual Anti-Nervios',
  desc: 'Control corporal bajo presión.'
}, {
  title: 'Kit de Follow-Up',
  desc: 'Reputación post reunión y networking.'
}, {
  title: 'Tracker de Ascenso 90 Días',
  desc: 'Métricas reales de valor percibido.'
}];
export function BonusesSection() {
  return <section className="py-12 px-4 bg-brand-black" data-id="element-23">
      <div className="max-w-4xl mx-auto" data-id="element-24">
        <div className="text-center mb-8" data-id="element-25">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-brand-red/10 border border-brand-red text-brand-red font-bold text-xs mb-4 animate-pulse" data-id="element-26">
            🔴 GRATIS POR HOY ÚNICAMENTE
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-text mb-2" data-id="element-27">
            +6 bonos exclusivos con tu compra
          </h2>
          <p className="text-brand-muted text-sm" data-id="element-28">
            Solo disponibles en esta página y solo hoy.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-29">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-dark border border-brand-gold/20 rounded-lg px-4 py-3" data-id="element-30">
              <div className="flex items-center gap-2 mb-1" data-id="element-31">
                <Gift size={14} className="text-brand-gold flex-shrink-0" data-id="element-32" />
                <span className="text-brand-gold text-[10px] font-bold tracking-wider" data-id="element-33">
                  BONO {i + 1}
                </span>
                <span className="text-brand-green text-[9px] font-bold bg-brand-green/15 px-1.5 py-0.5 rounded ml-auto flex-shrink-0" data-id="element-34">
                  GRATIS
                </span>
              </div>
              <h4 className="text-brand-text font-bold text-sm leading-tight" data-id="element-35">
                {bonus.title}
              </h4>
              <p className="text-brand-muted text-xs mt-1 leading-snug" data-id="element-36">
                {bonus.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brand-dark border-2 border-brand-gold rounded-lg p-4 max-w-lg mx-auto shadow-[0_0_30px_rgba(201,168,76,0.15)] flex flex-col items-center justify-center" data-id="element-37">
          <p className="text-lg font-bold text-brand-text text-center" data-id="element-38">
            Valor total de bonos:
          </p>
          <p className="text-center mt-1" data-id="element-39">
            <span className="text-brand-muted line-through text-base" data-id="element-40">
              $29.940
            </span>
            <span className="text-brand-gold font-bold text-lg ml-2" data-id="element-41">
              → $0 hoy
            </span>
          </p>
        </div>
      </div>
    </section>;
}